import React from 'react';

const AnalyticContext = React.createContext();

export default AnalyticContext;
